import { render } from "./ProjectCreate.vue?vue&type=template&id=b58e1232"
import script from "./ProjectCreate.vue?vue&type=script&lang=js"
export * from "./ProjectCreate.vue?vue&type=script&lang=js"
script.render = render

export default script